import { RouteProps } from 'react-router';
import { ENTITY_TYPE } from 'common/constants';
import { TimesheetComponent } from 'components/Timesheet/TimesheetComponent';
import BillingReportComponent from 'components/Reports/BillingReportComponent';
import TimesheetReportComponent from 'components/Reports/TimesheetReportComponent';
import UtilizationReportComponent from 'components/Reports/UtilizationReportComponent';
import AllocationVsTimesheetReportComponent from 'components/Reports/AllocationVsTimesheetReportComponent';
import ClientDetail from 'components/Clients/ClientDetail';
import Employees from 'components/Employee/Employee';
import EmployeeDetail from 'components/Employee/EmployeeDetail';
import MyTeam from 'components/Employee/MyTeam';
import Projects from 'components/Project/Projects';
import ProjectDetail from 'components/Project/ProjectDetail';
import Providers from 'components/Provider/Providers';
import ProviderDetail from 'components/Provider/ProviderDetail';
import Workflows from 'components/Workflow/Workflows';
import UserPage from 'pages/user';
import Roles from 'components/Roles/Roles';
import RoleDetail from 'components/Roles/RoleDetail';
import Users from 'pages/users';
import TimeOff from 'components/TimeOff/TimeOff';
import Regime from 'components/TimeOff/Regime';
import RegimeTypes from 'components/TimeOff/RegimeTypes';
import TimeOffRequest from 'components/TimeOff/Request/TimeOffRequest';
import HRCalendar from 'components/TimeOff/Calendar/HRCalendar';
import HolidayPage from 'components/TimeOff/Calendar/HolidayPage';
import WorkflowAdmin from 'components/Workflow/WorkflowAdmin';
import MyInvoices from 'components/AccountsPayable/MyInvoices/MyInvoices';
import InvoicesAccountsPayable from 'components/AccountsPayable/InvoicesAccountsPayable';
import InvoiceUpload from 'components/NewInvoice/Upload/InvoiceUpload';
import CorporateEntities from 'components/CorporateEntitites/CorporateEntities';
import TranslationsPage from 'components/Translation/TranslationPage';
import CorporateEntityDetail from 'components/CorporateEntitites/CorporateEntityDetail/CorporateEntityDetail';
import { TaxList } from 'components/TaxManagement';
import InvoiceConfigurationPage from 'components/InvoiceConfiguration/InvoiceConfigurationPage';
import AccountList from 'components/AccountManagement/AccountList';
import AccountDetail from 'components/AccountManagement/AccountDetail';
import ReconciliationPage from 'components/AccountManagement/ReconciliationPage';
import { DashboardComponent } from 'components/Dashboard/DashboardComponent';
import ComponentsShowcase from 'pages/showcase/components-showcase';
import ColorsShowcase from 'pages/showcase/color-showcase';
import TypographyShowcase from 'pages/showcase/typography-showcase';
import ShowcaseDataGrid from 'pages/showcase/datagrid-showcase';
import Clients from 'components/Clients/Clients';
import Notifications from 'components/notifications/Notifications';
import MyInvoiceDetail from 'components/AccountsPayable/MyInvoices/MyInvoiceDetail';
import Invoicing from 'components/Invoicing/Invoicing';
import EditRegimeType from 'components/TimeOff/EditRegimeType';
import NewRegimeType from 'components/TimeOff/newRegimeType';
import RegimeNew from 'components/TimeOff/RegimeNew';
import InvoiceDetailAccountsPayable from 'components/AccountsPayable/Detail/InvoiceDetailAccountsPayable';
import InvoicingDetail from 'components/Invoicing/Detail/InvoicingDetail';
import NewInvoicing from 'components/NewInvoice/NewInvoicing';
import { NotificationConfiguration } from 'components/notifications/Configuration';
import InvoiceTypeList from 'components/InvoiceTypeManagement/InvoiceTypeList';
import ScopeList from 'components/Scopes/ScopeList';
import ScopeDetail from 'components/Scopes/ScopeDetail';
import FunctionalityList from 'components/Functionalities/FunctionalityList';
import FunctionalityDetail from 'components/Functionalities/FunctionalityDetail';
import ScopeFunctionalityMatrix from 'components/Functionalities/ScopeFunctionalityMatrix';
import UnreconciledInvoicesReportComponent from 'components/Reports/UnreconciledInvoicesReportComponent';
import AiCreditPage from 'components/AiCredit/AiCreditPage';
import SkillsPage from 'components/HumanResources/Skills/SkillsPage';
import TrainingCertificationsPage from 'components/HumanResources/TrainingCertifications/TrainingCertificationsPage';
import TrainingCoursesPage from 'components/HumanResources/TrainingCourses/TrainingCoursesPage';
import ProfilesPage from 'components/HumanResources/Profiles/ProfilesPage';
import JobOpeningsPage from 'components/HumanResources/JobOpenings/JobOpeningsPage';
import SkillMatrixPage from 'components/HumanResources/SkillMatrix/SkillMatrixPage';
import OrgChartPage from 'components/HumanResources/OrgChart/OrgChartPage';
import MySkillsPage from 'components/HumanResources/MySkills/MySkillsPage';
import CvConfigurationPage from 'components/HumanResources/CvConfiguration/CvConfigurationPage';

export type RoutePermissionDefinition = RouteProps & {
  scopes?: string[];
  entityTypes?: ENTITY_TYPE[];
  identifier?: string;
};

const ROUTES: RoutePermissionDefinition[] = [
  {
    path: '/',
    element: <DashboardComponent />,
    identifier: 'ui.page.dashboard',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/clients',
    element: <Clients />,
    identifier: 'ui.nav.clients',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/client/new',
    element: <ClientDetail />,
    identifier: 'ui.nav.clients',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/client/detail/:id',
    element: <ClientDetail />,
    identifier: 'ui.nav.clients',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/projects',
    element: <Projects />,
    identifier: 'ui.nav.projects',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/project/new',
    element: <ProjectDetail />,
    identifier: 'ui.nav.projects',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/project/detail/:idProject',
    element: <ProjectDetail />,
    identifier: 'ui.nav.projects',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/employees',
    element: <Employees />,
    identifier: 'ui.nav.employees',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/employee/new',
    element: <EmployeeDetail />,
    identifier: 'ui.nav.employees',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/employee/detail/:id',
    element: <EmployeeDetail />,
    identifier: 'ui.nav.employees',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/myteam',
    element: <MyTeam />,
    identifier: 'ui.page.my-team',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/timesheet',
    element: <TimesheetComponent />,
    identifier: 'ui.nav.timesheet',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/billing',
    element: <BillingReportComponent />,
    identifier: 'ui.nav.reports.billing',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/timesheet',
    element: <TimesheetReportComponent />,
    identifier: 'ui.nav.reports.my-timesheet',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/unreconciled-invoices',
    element: <UnreconciledInvoicesReportComponent mode="ar" />,
    identifier: 'ui.nav.finance.unreconciled-ar',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/unreconciled-ap',
    element: <UnreconciledInvoicesReportComponent mode="ap" />,
    identifier: 'ui.nav.finance.unreconciled-ap',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/utilization',
    element: <UtilizationReportComponent />,
    identifier: 'ui.nav.reports.utilization',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/allocation-vs-timesheet',
    element: <AllocationVsTimesheetReportComponent />,
    identifier: 'ui.nav.reports.allocation-vs-timesheet',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/billing/client',
    element: <BillingReportComponent client />,
    identifier: 'ui.nav.reports.billing',
    entityTypes: [ENTITY_TYPE.CLIENT, ENTITY_TYPE.ANY],
  },
  {
    path: '/reports/timesheet/client',
    element: <TimesheetReportComponent client />,
    identifier: 'ui.nav.reports.my-timesheet',
    entityTypes: [ENTITY_TYPE.CLIENT, ENTITY_TYPE.ANY],
  },
  {
    path: '/providers',
    element: <Providers />,
    identifier: 'ui.nav.providers',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/provider/new',
    element: <ProviderDetail />,
    identifier: 'ui.nav.providers',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/provider/detail/:id',
    element: <ProviderDetail />,
    identifier: 'ui.nav.providers',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/users',
    element: <Users />,
    identifier: 'ui.admin.users',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/user/new',
    element: <UserPage />,
    identifier: 'ui.admin.users',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/user/detail/:id',
    element: <UserPage />,
    identifier: 'ui.admin.users',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/roles',
    element: <Roles />,
    identifier: 'ui.admin.roles',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/role/new',
    element: <RoleDetail />,
    identifier: 'ui.admin.roles',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/role/detail/:id',
    element: <RoleDetail />,
    identifier: 'ui.admin.roles',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/scopes',
    element: <ScopeList />,
    identifier: 'ui.admin.scopes',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/scope/new',
    element: <ScopeDetail />,
    identifier: 'ui.admin.scopes',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/scope/detail/:id',
    element: <ScopeDetail />,
    identifier: 'ui.admin.scopes',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/functionalities',
    element: <FunctionalityList />,
    identifier: 'ui.admin.functionalities',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/functionality/detail/:id',
    element: <FunctionalityDetail />,
    identifier: 'ui.admin.functionalities',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/functionality/matrix',
    element: <ScopeFunctionalityMatrix />,
    identifier: 'ui.admin.functionality-matrix',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.ANY],
  },
  {
    path: '/timeOff',
    element: <TimeOff />,
    identifier: 'ui.nav.hr.my-pto',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/timeOffHR',
    element: <TimeOff HRView={true} />,
    identifier: 'ui.nav.hr.manage-pto',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/timeOff/request',
    element: <TimeOffRequest HRView={false} />,
    identifier: 'ui.nav.hr.my-pto',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/timeOff/requestHR',
    element: <TimeOffRequest HRView={true} />,
    identifier: 'ui.nav.hr.manage-pto',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/timeOffRequest/detail/:id',
    element: <TimeOffRequest HRView={false} />,
    identifier: 'ui.nav.hr.my-pto',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/timeOffRequestHR/detail/:id',
    element: <TimeOffRequest HRView={true} />,
    identifier: 'ui.nav.hr.manage-pto',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/Calendar',
    element: <HRCalendar />,
    identifier: 'ui.nav.hr.my-pto',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/CalendarHR',
    element: <HRCalendar HRView={true} />,
    identifier: 'ui.nav.hr.manage-pto',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/Calendar/Holidays',
    element: <HRCalendar />,
    identifier: 'ui.nav.hr.holidays',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/Calendar/Holidays/new',
    element: <HolidayPage />,
    identifier: 'ui.nav.hr.holidays',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/Calendar/Holidays/edit/:id',
    element: <HolidayPage />,
    identifier: 'ui.nav.hr.holidays',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/workflows',
    element: <Workflows />,
    identifier: 'ui.admin.workflows',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/workflow/:id',
    element: <WorkflowAdmin />,
    identifier: 'ui.admin.workflows',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/corporateEntities',
    element: <CorporateEntities />,
    identifier: 'ui.admin.corporate-entities',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/corporateEntities/new',
    element: <CorporateEntityDetail />,
    identifier: 'ui.admin.corporate-entities',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/corporateEntities/detail/:id',
    element: <CorporateEntityDetail />,
    identifier: 'ui.admin.corporate-entities',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/invoice-configuration',
    element: <InvoiceConfigurationPage />,
    identifier: 'ui.admin.invoice-configuration',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/taxes',
    element: <TaxList />,
    identifier: 'ui.admin.taxes',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/accounts',
    element: <AccountList />,
    identifier: 'ui.nav.finance.accounts',
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
  },
  {
    path: '/account/detail/:id',
    element: <AccountDetail />,
    identifier: 'ui.nav.finance.accounts',
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
  },
  {
    path: '/account/detail/:accountId/reconcile/:seatId',
    element: <ReconciliationPage />,
    identifier: 'ui.nav.finance.accounts',
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
  },
  {
    path: '/invoice-types',
    element: <InvoiceTypeList />,
    identifier: 'ui.admin.invoice-types',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/regime',
    element: <Regime />,
    identifier: 'ui.nav.hr.regime',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/regime/new',
    element: <RegimeNew />,
    identifier: 'ui.nav.hr.regime',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/regime/:regimeId/types',
    element: <RegimeTypes />,
    identifier: 'ui.nav.hr.regime',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/regime/:regimeId/types/new',
    element: <NewRegimeType />,
    identifier: 'ui.nav.hr.regime',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/regime/:regimeId/types/edit/:typeId',
    element: <EditRegimeType />,
    identifier: 'ui.nav.hr.regime',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/notifications',
    element: <Notifications />,
    identifier: 'ui.page.notifications',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/translations',
    element: <TranslationsPage />,
    identifier: 'ui.admin.translations',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/ai-credits',
    element: <AiCreditPage />,
    identifier: 'ui.nav.ai-credits',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/showcase/components',
    element: <ComponentsShowcase />,
    identifier: 'ui.page.showcase',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/showcase/colors',
    element: <ColorsShowcase />,
    identifier: 'ui.page.showcase',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/showcase/typography',
    element: <TypographyShowcase />,
    identifier: 'ui.page.showcase',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/showcase/datagrid',
    element: <ShowcaseDataGrid />,
    identifier: 'ui.page.showcase',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/myInvoices',
    element: <MyInvoices />,
    identifier: 'ui.nav.invoices.my-invoices',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.PROVIDER],
  },
  {
    path: '/myInvoices/upload',
    element: <InvoiceUpload />,
    identifier: 'ui.nav.invoices.upload',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.PROVIDER],
  },
  {
    path: '/accountspayable',
    element: <InvoicesAccountsPayable />,
    identifier: 'ui.nav.invoices.accounts-payable',
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
  },
  {
    path: '/accountspayable/all',
    element: <InvoicesAccountsPayable />,
    identifier: 'ui.nav.invoices.accounts-payable',
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
  },
  {
    path: '/invoicing',
    element: <Invoicing />,
    identifier: 'ui.nav.invoices.invoicing',
    entityTypes: [ENTITY_TYPE.EMPLOYEE, ENTITY_TYPE.CORPORATE_ENTITY, ENTITY_TYPE.CLIENT],
  },
  {
    path: '/invoicing/newinvoice',
    element: <NewInvoicing />,
    identifier: 'ui.nav.invoices.new-invoice',
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
  },
  {
    path: '/invoicing/detail/:id',
    element: <InvoicingDetail />,
    identifier: 'ui.nav.invoices.invoicing',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/invoice/detail/:id',
    element: <MyInvoiceDetail />,
    identifier: 'ui.nav.invoices.my-invoices',
    entityTypes: [ENTITY_TYPE.ANY],
  },
  {
    path: '/accountspayable/validate/:id',
    element: <InvoiceDetailAccountsPayable onlyView={false} />,
    identifier: 'ui.nav.invoices.accounts-payable',
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
  },
  {
    path: '/accountspayable/detail/:id',
    element: <InvoiceDetailAccountsPayable onlyView={true} />,
    identifier: 'ui.nav.invoices.accounts-payable',
    entityTypes: [ENTITY_TYPE.CORPORATE_ENTITY],
  },
  {
    path: '/notifications/configuration',
    element: <NotificationConfiguration />,
    identifier: 'ui.admin.notifications',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/hr/training',
    element: <SkillsPage />,
    identifier: 'ui.nav.hr.training',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/hr/training-certifications',
    element: <TrainingCertificationsPage />,
    identifier: 'ui.nav.hr.training-certifications',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/hr/training-courses',
    element: <TrainingCoursesPage />,
    identifier: 'ui.nav.hr.training-courses',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/hr/profiles',
    element: <ProfilesPage />,
    identifier: 'ui.nav.hr.profiles',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/hr/cv-configuration',
    element: <CvConfigurationPage />,
    identifier: 'ui.nav.hr.cv-configuration',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/hr/job-openings',
    element: <JobOpeningsPage />,
    identifier: 'ui.nav.hr.job-openings',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/hr/skill-matrix',
    element: <SkillMatrixPage />,
    identifier: 'ui.nav.hr.skill-matrix',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/hr/org-chart',
    element: <OrgChartPage />,
    identifier: 'ui.nav.hr.org-chart',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
  {
    path: '/my-skills',
    element: <MySkillsPage />,
    identifier: 'ui.nav.my-skills',
    entityTypes: [ENTITY_TYPE.EMPLOYEE],
  },
];

export default ROUTES;
